export default __webpack_public_path__ + "static/media/txt_title1.45e2f54d.svg";